import { FC, ReactNode, useState } from 'react';

import styled from 'styled-components';

import { DownArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

const Container = styled.div`
  width: 100vw;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
`;

const ChildContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: 0 -10px 20px 0 ${({ theme }) => theme.palette.veryLightBlack};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ToggleButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  font-weight: bold;
`;

const ToggleButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 169px;
  fill: ${({ theme }) => theme.palette.brownishGrey};
  cursor: pointer;
  background: url(/static/images/detaylar-bg.webp) no-repeat no-repeat top;
`;

const ToggleButtonTitle = styled.div`
  padding: 3px 9px 3px 0;
`;

const ToggleButtonIconContainer = styled.a`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div<{ isOpen: boolean }>`
  span {
    display: flex;
  }
  svg {
    transform: ${({ isOpen }) => (isOpen ? 'rotateX(0deg)' : 'rotate(180deg)')};
  }
`;

const BottomDrawer: FC<{
  toggleButtonTitle?: string;
  closable?: boolean;
  children: (isToggled: boolean) => ReactNode;
}> = ({ children, toggleButtonTitle = 'Detaylar', closable = true }) => {
  const [isToggled, setIsToggled] = useState(true);
  const toggleVisibility = (): void => setIsToggled((state) => !state);

  return (
    <Container data-testid='bottom-drawer'>
      {closable ? (
        <ToggleButtonContainer>
          <ToggleButton onClick={toggleVisibility}>
            <ToggleButtonTitle>{toggleButtonTitle}</ToggleButtonTitle>
            <ToggleButtonIconContainer>
              <IconWrapper isOpen={isToggled}>
                <CustomIcon
                  icon={DownArrowIcon}
                  paletteColor='white'
                  data-testid='icon-container'
                  isOpen={isToggled}
                />
              </IconWrapper>
            </ToggleButtonIconContainer>
          </ToggleButton>
        </ToggleButtonContainer>
      ) : null}
      <ChildContainer>{children && children(isToggled)}</ChildContainer>
    </Container>
  );
};

export default BottomDrawer;
